import { createSelector, Selector } from '@ngrx/store';
import { IdentityState } from './identity.state';

export const selectIdentityAccount = (identitySelector: Selector<object, IdentityState>) =>
  createSelector(identitySelector, (state: IdentityState) => state.account);

export const selectIdentityGeneralContractorName = (
  identitySelector: Selector<object, IdentityState>
) => createSelector(identitySelector, (state: IdentityState) => state.generalContractor?.name);

export const selectIdentityGeneralContractorId = (
  identitySelector: Selector<object, IdentityState>
) => createSelector(identitySelector, (state: IdentityState) => state.generalContractor?.id);
